import { ComponentProps, FC, useCallback } from "react"
import { IProductV1 } from "src/domain/entities"
import { productAddService } from "src/domain/services/product/productAddService"
import { useAuth } from "src/hooks"
import { FormikOnSubmit } from "src/utils/types"
import { IProductAddFormFields, ProductAddDrawerFormView } from "."

interface Props
	extends Omit<ComponentProps<typeof ProductAddDrawerFormView>, "handleSubmit"> {
	onSuccess: (product: IProductV1) => void
}

export const ProductAddDrawerFormController: FC<Props> = ({ onSuccess, ...rest }) => {
	const { token } = useAuth()

	const handleSubmit = useCallback<FormikOnSubmit<IProductAddFormFields>>(
		async (values, { setErrors }) => {
			try {
				const product = await productAddService(values, token)
				onSuccess(product)
				rest.onClose()
			} catch (err) {
				const message =
					err instanceof Error ? err.message : "Something went wrong"
				setErrors({ name: message })
			}
		},
		[onSuccess, rest, token],
	)

	return <ProductAddDrawerFormView handleSubmit={handleSubmit} {...rest} />
}
